<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "App",
  components: {

  },
  created() {
    // this.$router.push({ name: "appLogin" });
  },
}
</script>

<style>
/* *统一字体
*{
  font-family: 'PingFang-SC-Semibold';
} */
html,
body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
    /* background:white; */
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    height: 100%;
    box-sizing: inherit;
}
.main-body {
  width: 80%;
  margin: 0 auto;
}



/**style for top bar */
.van-nav-bar{
  background:linear-gradient(to right, #77BBE3, #1270C6);
}
#reset /deep/ .van-ellipsis{
  font-size:18px;
	color: white !important;
}
#reset /deep/ .van-nav-bar__text{
	color: white !important;
}
/** top bar style end*/

</style>
